export const VISIBLE_BANNER_TYPES = new Set(['info', 'warning']);
